import React, { useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getBranch } from '../../store/user/selectors';
import CustomerListPanel from './CustomerListPanel';
import OpenDepositsView from './OpenDepositsView';
import './CustomerCenter.css';

interface ContentProps {
  branchId: string;
  branchName: string;
}

/** Branch key on parent resets list filters and modals when activity changes. */
const CustomerCenterContent: React.FC<ContentProps> = ({ branchId, branchName }) => {
  const { t } = useTranslation('scenes.customerCenter');
  const [view, setView] = useState<'customers' | 'open'>('customers');
  const branchLabel = branchName
    ? t('branchLabelNamed', { branchName, branchId })
    : t('branchLabelAnonymous', { branchId });

  return (
    <div className="main-container flex-grow-1 customer-center">
      <div className="container-fluid">
        <div className="pb-3 pt-3" id="ux_page_title">
          <div className="align-items-baseline d-flex flex-wrap gap-2 page-title">
            <h1 className="h5 font-weight-700 mb-0 d-inline-flex">{t('title')}</h1>
            {branchId ? <span className="customer-center__activity text-muted small">{branchLabel}</span> : null}
          </div>
        </div>

        {!branchId ? (
          <div className="customer-center__empty">{t('emptySelectActivity')}</div>
        ) : (
          <>
            <Nav
              variant="tabs"
              activeKey={view}
              onSelect={(key) => setView(key === 'open' ? 'open' : 'customers')}
              className="mb-3"
              aria-label={t('title')}
            >
              <Nav.Link eventKey="customers">{t('tabCustomers')}</Nav.Link>
              <Nav.Link eventKey="open">{t('tabOpen')}</Nav.Link>
            </Nav>
            {view === 'customers' ? (
              <CustomerListPanel branchId={branchId} />
            ) : (
              <OpenDepositsView branchId={branchId} />
            )}
          </>
        )}
      </div>
    </div>
  );
};

const CustomerCenter: React.FC = () => {
  const branchData: unknown = useSelector(getBranch);
  let branchId = '';
  let branchName = '';
  if (typeof branchData === 'object' && branchData !== null) {
    if ('id' in branchData) {
      const raw: unknown = branchData.id;
      if (typeof raw === 'string' || typeof raw === 'number') branchId = String(raw);
    }
    if ('name' in branchData && typeof branchData.name === 'string') branchName = branchData.name.trim();
  }
  return <CustomerCenterContent key={branchId} branchId={branchId} branchName={branchName} />;
};

export default CustomerCenter;
